export default __webpack_public_path__ + "static/media/sign-out-alt-solid.57707bd6.svg";